import { ReferringPhysicianView } from '../../../model/referring-physician/referring-physician-view';
import { Component, OnInit } from '@angular/core';
import { WizardStep } from 'src/app/wizard/wizard.component';
import { StudyReportWizardService } from 'src/app/services/wizard/study-report/study-report.wizard.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';


@Component({
  selector: 'app-study-report-referring-physician',
  templateUrl: './study-report-referring-physician.component.html'
})
export class StudyReportReferringPhysicianComponent implements OnInit, WizardStep {

  loading: boolean;
  completed: boolean;
  isInit: boolean;
  referringPhysicianView: ReferringPhysicianView;

  constructor(private studyReportWizardService: StudyReportWizardService
    , private notificationToastService: NotificationToastService) {

  }

  activate(): void {

  }

  save(): void {

  }
  get valid(): boolean {
    return this.completed;
  }

  async ngOnInit() {
    try {
      this.loading = true;
      this.referringPhysicianView = await this.studyReportWizardService
        .getReferringPhysicianView();
      this.completed = true;
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Médico derivante');
    } finally {
      this.loading = false;
    }
  }
}
